var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { createContext, useCallback, useContext, useRef, useState } from 'react';
import CustomDialog from './Dialog';
var DialogContext = createContext(Promise.reject.bind(Promise));
export var useDialog = function () { return useContext(DialogContext); };
export var DialogProvider = function (_a) {
    var children = _a.children;
    var _b = useState(false), open = _b[0], setOpen = _b[1];
    var _c = useState({
        title: '',
        message: '',
        variant: 'info',
    }), options = _c[0], setOptions = _c[1];
    var resolveRef = useRef(function () { });
    var openDialog = useCallback(function (options) {
        setOptions(options);
        setOpen(true);
        return new Promise(function (resolve) {
            resolveRef.current = resolve;
        });
    }, []);
    var handleClose = function () {
        setOpen(false);
        resolveRef.current({
            confirmed: true,
        });
    };
    var handleCancel = function () {
        setOpen(false);
        resolveRef.current({
            confirmed: false,
        });
    };
    return (_jsxs(_Fragment, { children: [_jsx(DialogContext.Provider, __assign({ value: openDialog }, { children: children }), void 0),
            _jsx(CustomDialog, __assign({ open: open, handleClose: handleClose, handleCancel: handleCancel }, options), void 0)] }, void 0));
};
